<script>
import Layout from "../../layouts/main";
// import PageHeader from "@/components/page-header";
// import { required } from "vuelidate/lib/validators";
import Spinner from "vue-simple-spinner";
import * as cloneDeep from "lodash.clonedeep";
import * as moment from "moment";
import { virtualAccountList, virtualAccountAdd, getAccountStatement, downloadExcel } from "@/state/helpers";
import {
  FETCH_VIRTUAL_ACCOUNTS,
  // CREATE_VIRTUAL_ACCOUNT,
  FETCH_ALL_PAYMENT_CHANNEL,
  FETCH_MERCHANTS_LIST,
  FETCH_VIRTUAL_ACCOUNTS_MASTER_MERCHANT,
  FETCH_ACCOUNT_STATEMENT,
  DOWNLOAD_VA_EXCEL_STATEMENT,
} from "@/state/actions.type";
import Multiselect from "vue-multiselect";
import Filters from '../../../components/filters.vue';
import DownloadBtn from '../../../components/download-btn.vue';
import PerPage from '../../../components/per-page.vue';

export default {
  components: {
    Layout,
    Spinner,
    PerPage,
    Multiselect,
    Filters,
    DownloadBtn
},
  data() {
    return {
      errorMessage: "",
      createError: false,
      successfulMessage: false,
      submitted: false,
      isVirtualAccountFlow : false,
      // showmodal: false,
      typesubmit: false,
      merchants: [],
      fromDate: "",
      toDate: "",
      selectedAccountNo:"",
      isPayoutEnabled:false,
      vaAccountTransactionsData: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [2, 10, 25, 50, 100],
      sortBy: "date",
      sortDesc: true,

      fields: [
        { key: "date", sortable: true, label: "views.payouts.table.fields.date", tooltip: "views.payouts.table.fields.date" },
        { key: "vaaccount_no", sortable: true, label: "views.payouts.table.fields.vaaccount_no", tooltip: "views.payouts.table.fields.vaaccount_no" },
        { key: "amount", sortable: true, label: "views.payouts.table.fields.txn_amount", tooltip: "views.payouts.table.fields.txn_amount" },
        { key: "txn_type", sortable: true, label: "views.payouts.table.fields.txn_type", tooltip: "views.payouts.table.fields.txn_type"},
        { key: "balance", sortable: true, label: "views.payouts.table.fields.balance", tooltip: "views.payouts.table.fields.balance"},
      ],
      // chaiPayVirtualAccounts: { fields for create virtual account
      //   map_id: `mapid_${(this._uid + this.$uuid.v1())
      //     .replace(/-/g, "")
      //     .substring(1, 13)
      //     .toUpperCase()}${this._uid}`,
      //   customer_name: "",
      //   channel_key: "EPAY_PAYOUT",
      //   bank_code: "WOORIBANK",
      //   personal_info: {
      //     phone: "",
      //     email: "",
      //     address: "",
      //     id: `pinfo_${(this._uid + this.$uuid.v1())
      //       .replace(/-/g, "")
      //       .substring(1, 13)
      //       .toUpperCase()}${this._uid}`,
      //   },
      // },
    };
  },
  methods: {
    ...virtualAccountList,
    ...virtualAccountAdd,
    ...downloadExcel,
    ...getAccountStatement,
    // flow start for create virtual account

    // openModal() {
    //   this.resetPayoutForm();
    //   this.submitted = false;
    //   this.showmodal = true;
    // },

    // hideModal() {
    //   this.showmodal = false;
    //   this.submitted = false;
    //   this.resetPayoutForm();
    // },

    // resetPayoutForm() {
    //   this.chaiPayVirtualAccounts = {
    //     map_id: `mapid_${(this._uid + this.$uuid.v1())
    //       .replace(/-/g, "")
    //       .substring(1, 13)
    //       .toUpperCase()}${this._uid}`,
    //     customer_name: "",
    //     channel_key: "EPAY_PAYOUT",
    //     bank_code: "WOORIBANK",
    //     personal_info: {
    //       phone: "",
    //       email: "",
    //       address: "",
    //     },
    //   };
    // },

    // handleSubmit() {
    //   this.submitted = true;
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }
    //   const addVirtualAccount = {
    //     customer_name: this.chaiPayVirtualAccounts.customer_name.toUpperCase(),
    //     channel_key: this.chaiPayVirtualAccounts.channel_key,
    //     bank_code: this.chaiPayVirtualAccounts.bank_code,
    //     personal_info: {
    //       id: `${(this._uid + this.$uuid.v1())
    //         .replace(/-/g, "")
    //         .substring(1, 13)
    //         .toUpperCase()}${this._uid}`,
    //       phone: this.chaiPayVirtualAccounts.phone,
    //       email: this.chaiPayVirtualAccounts.email,
    //       address: this.chaiPayVirtualAccounts.address,
    //     },
    //     env: "",
    //   };
    //   addVirtualAccount["map_id"] =
    //     addVirtualAccount.customer_name.trim().replace(/ /g, "_") +
    //     `_${(this._uid + this.$uuid.v1())
    //       .replace(/-/g, "")
    //       .substring(1, 13)
    //       .toUpperCase()}${this._uid}`;
    //   this.submitted = false;

    //   this.$store
    //     .dispatch(`virtualaccount/${CREATE_VIRTUAL_ACCOUNT}`, addVirtualAccount)
    //     .then((result) => {
    //       setTimeout(() => {
    //         this.showmodal = false;
    //         this.successfulMessage = false;
    //         this.createError = false;
    //         this.resetPayoutForm();
    //       }, 3000);
    //       if (result.is_success == "false") {
    //         (this.errorMessage = result.message), (this.createError = true);
    //       } else {
    //         this.successfulMessage = true;
    //       }
    //     })
    //     .catch((error) => {
    //       this.createError = true;
    //       setTimeout(() => {
    //         this.resetPayoutForm();
    //         this.showmodal = false;
    //       }, 3000);
    //       console.log(error);
    //     });
    // },
    // flow end for create virtual account
    fetchVirtualAccounts() {
      if(this.isMasterMerchant) {
        const merchants = this.merchants.map(merchant => merchant.email_id)
        this.$store.dispatch(`virtualaccount/${FETCH_VIRTUAL_ACCOUNTS_MASTER_MERCHANT}`, {
          "filters": {
            "merchants": merchants
          }
        });
      } else {
        this.$store.dispatch(`virtualaccount/${FETCH_VIRTUAL_ACCOUNTS}`);
      }
    },
    fetchPaymentChannels() {
      this.$store.dispatch(`paymentChannels/${FETCH_ALL_PAYMENT_CHANNEL}`, {
        country: [],
        paymentMethod: "",
        paymentType: "PAYOUT"
      })
        .then((response) => {
          this.isVirtualAccountFlow = response && response.find(channel => channel.is_va_flow) ? true : false;
          this.isPayoutEnabled =  response && response.find(channel => channel.is_enabled) ? true : false;
        });
    },
    merchantSelected() {
      this.fetchVirtualAccounts();
    },
    onCopySuccess() {
      this.$notify({
        type: "success",
        text: "Account No copied to clipboard.",
        closeOnClick: true,
      });
    },
    dateChanged(value) {
      this.fromDate = value[0];
      this.toDate = value[1];
      if(this.selectedAccountNo){
        this.refreshRecord(); 
      }     
    },

    sortByDate(a,b, key) {
      if(key == 'date') {
        const d1 = new Date(a[key]).getTime();
        const d2 = new Date(b[key]).getTime();
        return d1-d2;
      }
    },
    exportVirtualAccTransactionIntoExcel() {
      var from_date = ''
      var to_date = ''
      if(this.fromDate) {
        from_date = moment(this.fromDate, 'DD-MM-YYYY HH:mm').format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        from_date = moment('2018-01-01T00:00:00.000').format("YYYY-MM-DDTHH:mm:ssZ");
      }

      if(this.toDate) {
        to_date = moment(this.toDate, 'DD-MM-YYYY HH:mm').format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        to_date = moment().format("YYYY-MM-DDTHH:mm:ssZ");
      }
      const excelDate = {
        dates: {
          from: from_date,
          to: to_date,
        },
        account_no: this.selectedAccountNo,
      };
      this.$store.dispatch(
        `accountstatement/${DOWNLOAD_VA_EXCEL_STATEMENT}`,
        excelDate
      );
    },

    refreshRecord() {
      var from_date = ''
      var to_date = ''
      if(this.fromDate) {
        from_date = moment(this.fromDate, 'DD-MM-YYYY HH:mm').format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        from_date = moment('2018-01-01T00:00:00.000').format("YYYY-MM-DDTHH:mm:ssZ");
      }

      if(this.toDate) {
        to_date = moment(this.toDate, 'DD-MM-YYYY HH:mm').format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        to_date = moment().format("YYYY-MM-DDTHH:mm:ssZ");
      }
      const postData = {
        dates: {
          from: from_date,
          to: to_date,
          page: this.currentPage,
          pagesize: this.perPage,
        },
        account_no: this.selectedAccountNo,
      };
      this.$store.dispatch(
        `accountstatement/${FETCH_ACCOUNT_STATEMENT}`,
        postData
      );
    },

    fetchVirtualAccountsTransactions(val, channel_key){
      if(channel_key !== 'BBL_PAYOUT'){
        this.selectedAccountNo = val
        this.refreshRecord()
      }
    }
  },

  computed: {
    isFetchingTransactions() {
      return this.$store.state.virtualaccount.isFetchingData;
    },

    fetchVirtualAccountsList() {
      return this.$store.state.virtualaccount.virtualAccounts;
    },

    userPermissions() {
      return this.$store.getters["auth/getUserPermissionsList"];
    },

    isMasterMerchant() {
      return this.$store.state.auth.currentUser.is_master_merchant;
    },

    merchantListDataFromStore() {
      return this.$store.state.masterMerchant.content;
    },
    rows() {
      return this.$store.state.accountstatement.total_elements;
    },

    accountsDataFromStore() {
      return this.$store.state.accountstatement.accountStatement;
    },

  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    perPage: function (val) {
      this.refreshRecord();
    },
    // eslint-disable-next-line no-unused-vars
    currentPage: function (val) {
      this.refreshRecord();
    },

    accountsDataFromStore() {
      this.vaAccountTransactionsData = cloneDeep(this.accountsDataFromStore);
    },
  },

  onFiltered(filteredItems) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  },

  // validations: {
  //   chaiPayVirtualAccounts: {
  //     customer_name: { required },
  //     channel_key: { required },
  //     map_id: { required },
  //     bank_code: { required },
  //   },
  // },
  filters: {
    date(value) {
        return moment(value).format("DD MMM YYYY");
    },
    time(value) {
        return 'at ' + moment(value).format("hh:mm A");
    },
  },

  created() {
    if(this.isMasterMerchant){
      this.$store.dispatch(`masterMerchant/${FETCH_MERCHANTS_LIST}`, {
        pageIndex: 1,
        pagesize: 10,
        filters: { source: "default" },
      }).then((response) => {
        if(response.content.length > 0) {
          this.fetchVirtualAccounts();
        }
      });
    } else {
      this.fetchVirtualAccounts();
      this.fetchPaymentChannels();
    }
    
  },

  beforeDestroy() {
    this.$store.state.accountstatement.total_elements = 0;
    this.$store.dispatch("notification/clear");
  },
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" /> -->
      <div class="row justify-content-end mb-3">
        <multiselect
          v-if="isMasterMerchant"
          v-model="merchants"
          :options="merchantListDataFromStore"
          @input="merchantSelected"
          placeholder="Search Merchants"
          track-by="email_id"
          label="email_id"
          class="sm-multiselect col-md-3"
          :searchable="true"
          :multiple="true"
          :taggable="true"
        ></multiselect>
      </div>
      <div v-if="!isPayoutEnabled && fetchVirtualAccountsList.length === 0" class="d-flex justify-content-center align-items-center flex-column dummy-virtual-account" style="border-radius: 12px; background: rgba(220, 218, 213, 0.30);">
        <svg xmlns="http://www.w3.org/2000/svg" width="98" height="98" viewBox="0 0 98 98" fill="none">
            <ellipse cx="49" cy="95.0601" rx="49" ry="2.94" fill="#DCDAD5"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5205 24.5002C23.5205 21.2527 26.1531 18.6202 29.4005 18.6202H56.799C56.9921 18.6202 57.1841 18.6296 57.3746 18.6484V31.8064C57.3746 33.9714 59.1296 35.7264 61.2946 35.7264H73.5005V60.0959C72.5534 59.8891 71.5697 59.7802 70.5605 59.7802C62.9832 59.7802 56.8405 65.9228 56.8405 73.5002C56.8405 75.7433 57.3788 77.8606 58.3333 79.7302H29.4005C26.1531 79.7302 23.5205 77.0976 23.5205 73.8502V24.5002ZM59.5521 81.6902H29.4005C25.0706 81.6902 21.5605 78.1801 21.5605 73.8502V24.5002C21.5605 20.1702 25.0706 16.6602 29.4005 16.6602H56.799C58.8783 16.6602 60.8725 17.4862 62.3428 18.9564L73.1643 29.7779C74.6345 31.2482 75.4605 33.2424 75.4605 35.3217V35.6567L75.4608 35.7264L75.4605 60.681C80.618 62.6536 84.2805 67.6492 84.2805 73.5002C84.2805 81.0775 78.1379 87.2202 70.5605 87.2202C66.053 87.2202 62.0532 85.0465 59.5521 81.6902ZM32.6276 30.6672C33.0103 30.2845 33.6308 30.2845 34.0135 30.6672L37.4855 34.1392L40.9576 30.6672C41.3403 30.2845 41.9608 30.2845 42.3435 30.6672C42.7262 31.0499 42.7262 31.6704 42.3435 32.0531L38.8715 35.5252L42.3435 38.9972C42.7262 39.3799 42.7262 40.0004 42.3435 40.3831C41.9608 40.7658 41.3403 40.7658 40.9576 40.3831L37.4855 36.9111L34.0135 40.3831C33.6308 40.7658 33.0103 40.7658 32.6276 40.3831C32.2449 40.0004 32.2449 39.3799 32.6276 38.9972L36.0996 35.5252L32.6276 32.0531C32.2449 31.6704 32.2449 31.0499 32.6276 30.6672ZM32.3405 49.4902C32.3405 48.1371 33.4374 47.0402 34.7905 47.0402H49.4905C50.8436 47.0402 51.9405 48.1371 51.9405 49.4902C51.9405 50.8433 50.8436 51.9402 49.4905 51.9402H34.7905C33.4374 51.9402 32.3405 50.8433 32.3405 49.4902ZM34.7905 49.0002C34.5199 49.0002 34.3005 49.2195 34.3005 49.4902C34.3005 49.7608 34.5199 49.9802 34.7905 49.9802H49.4905C49.7612 49.9802 49.9805 49.7608 49.9805 49.4902C49.9805 49.2195 49.7612 49.0002 49.4905 49.0002H34.7905ZM34.7905 54.8802C33.4374 54.8802 32.3405 55.9771 32.3405 57.3302C32.3405 58.6833 33.4375 59.7802 34.7905 59.7802H62.2305C63.5836 59.7802 64.6805 58.6833 64.6805 57.3302C64.6805 55.9771 63.5836 54.8802 62.2305 54.8802H34.7905ZM34.3005 57.3302C34.3005 57.0595 34.5199 56.8402 34.7905 56.8402H62.2305C62.5012 56.8402 62.7205 57.0595 62.7205 57.3302C62.7205 57.6008 62.5012 57.8202 62.2305 57.8202H34.7905C34.5199 57.8202 34.3005 57.6008 34.3005 57.3302ZM78.4805 24.7214C77.8371 23.8081 76.6784 23.4136 75.6114 23.7447C73.9414 24.2629 73.262 26.2589 74.269 27.6883L76.4048 30.72C77.0667 31.6595 77.425 32.7793 77.4314 33.9286L77.4522 37.6543C77.4601 39.0793 78.6209 40.2285 80.046 40.2222C81.4727 40.2159 82.624 39.0539 82.617 37.6271L82.597 33.5805C82.5872 31.6034 81.9715 29.6768 80.8328 28.0604L78.4805 24.7214ZM76.1923 25.6167C76.4473 25.5375 76.7244 25.6318 76.8782 25.8502L79.2305 29.1892C80.1384 30.4779 80.6292 32.0139 80.637 33.5902L80.657 37.6368C80.6587 37.9807 80.3812 38.2607 80.0373 38.2623C79.6939 38.2638 79.4141 37.9868 79.4122 37.6433L79.3913 33.9177C79.3827 32.368 78.8996 30.8581 78.0071 29.5911L75.8713 26.5595C75.6306 26.2178 75.793 25.7406 76.1923 25.6167ZM58.8005 73.5002C58.8005 67.0053 64.0657 61.7402 70.5605 61.7402C77.0554 61.7402 82.3205 67.0053 82.3205 73.5002C82.3205 79.995 77.0554 85.2602 70.5605 85.2602C64.0657 85.2602 58.8005 79.995 58.8005 73.5002ZM68.1105 67.1302C68.1105 65.7771 69.2074 64.6802 70.5605 64.6802C71.9136 64.6802 73.0105 65.7771 73.0105 67.1302V73.0102C73.0105 74.3633 71.9136 75.4602 70.5605 75.4602C69.2074 75.4602 68.1105 74.3633 68.1105 73.0102V67.1302ZM70.5605 66.6402C70.2899 66.6402 70.0705 66.8595 70.0705 67.1302V73.0102C70.0705 73.2808 70.2899 73.5002 70.5605 73.5002C70.8312 73.5002 71.0505 73.2808 71.0505 73.0102V67.1302C71.0505 66.8595 70.8312 66.6402 70.5605 66.6402ZM70.5605 82.3202C69.2074 82.3202 68.1105 81.2233 68.1105 79.8702C68.1105 78.5171 69.2074 77.4202 70.5605 77.4202C71.9136 77.4202 73.0105 78.5171 73.0105 79.8702C73.0105 81.2233 71.9136 82.3202 70.5605 82.3202ZM70.0705 79.8702C70.0705 80.1408 70.2899 80.3602 70.5605 80.3602C70.8312 80.3602 71.0505 80.1408 71.0505 79.8702C71.0505 79.5995 70.8312 79.3802 70.5605 79.3802C70.2899 79.3802 70.0705 79.5995 70.0705 79.8702Z" fill="black" fill-opacity="0.5"/>
        </svg>
        <p class="mb-2 mt-4" style="font-size: 18px; font-style: normal; font-weight: 500;">You don’t have any account connected yet!</p>
        <p class="mb-2" style="font-size: 14px; font-style: normal; font-weight: 400; color: rgba(0, 0, 0, 0.50);">Please connect a payout channel in order to activate an account.</p>
        <!-- <button
            v-if="userPermissions.includes('create-recons') || userRoles.includes('admin') || userRoles.includes('sub-admin')"
            class="btn btn-primary mt-4"
            style="height: 44px; line-height: 20px;"
            @click="$router.push({name: 'Upload Files', query: {showFileUploadmodal: true}})"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13.6997 7.41634C16.6997 7.67467 17.9247 9.21634 17.9247 12.5913V12.6997C17.9247 16.4247 16.4331 17.9163 12.7081 17.9163H7.28307C3.55807 17.9163 2.06641 16.4247 2.06641 12.6997V12.5913C2.06641 9.24134 3.27474 7.69967 6.22474 7.42467M9.99974 12.4997V3.01634M12.7914 4.87467L9.99974 2.08301L7.20807 4.87467" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t("views.reconciliation.add_files") }}
        </button> -->
        <button
            class="btn btn-primary mt-4"
            style="height: 44px; line-height: 20px;"
            @click="$router.push({name: 'Payment Channels', query: { tab: 'Payout Channels' }})"
        >
           + Connect Payout Channel
        </button>
      </div>
    <div v-else>
<!--   
    <button
      href="javascript:void(0);"
      v-if="userPermissions.includes('create-virtual-accounts') && isVirtualAccountFlow == true && !isMasterMerchant"
      class="btn btn-primary mb-4 "
      @click="openModal()"
    >
      {{ $t("views.payouts.virtual-account") }}
    </button> -->

    <div class="row">
      <div
        class="col-xl-3 col-sm-6"
        v-for="(data, index) in fetchVirtualAccountsList"
        :key="index"
      >
        <div @click="fetchVirtualAccountsTransactions(data.account_no, data.channel_key)" class="card virtual-acc-card"
         :class="{
            'active': selectedAccountNo ==  data.account_no,
          }"
        >
          <div class="">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p style="font-size: 14px;margin-bottom: 20px;line-height: 20px;height: 40px;">
                  {{ `${data.account_name}` }}
                </p>
              </div>
              <img :src="data.channel_logo" class="w-25" alt="">
            </div>
            <p class="" style="cursor: pointer;font-size: 10px;line-height: 16px;margin-bottom: 16px;" v-clipboard:copy="data.account_no" v-clipboard:success="onCopySuccess" :title="data.account_no" v-b-tooltip.hover>
              {{ `${ $t('views.payouts.acc_no') }:` }}
              <span style="display: block;color: rgba(0, 0, 0, 0.50);">{{data.account_no}}</span>
            </p>
            <div style="font-size: 14px;line-height: 20px;" v-if="!['BBL_PAYOUT', 'PAYNAMICS_PAYOUT'].includes(data.channel_key)">
              {{
                data.balance.toLocaleString("en-US", {
                  style: "currency",
                  currency: data.currency,
                })
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex" style="justify-content: space-between;align-items: center;">
          <div> 
            <div style="margin-top: 5px;font-size: 18px;line-height: 24px;">Transactions</div>
            <div style="font-size: 12px;color: rgba(0, 0, 0, 0.50);font-weight: 400;line-height: 16px;margin-top: 2px;">Below are the <span class="text-chai">transactions</span> for the selected account.</div>
          </div>
          <download-btn @download-button-clicked="exportVirtualAccTransactionIntoExcel()" />
        </div>
        <div style="border: 1px rgba(220, 218, 213, 0.30) solid;margin-top: 16px;margin-bottom: 16px;"></div>
        <filters class="mb-3" @date-change="dateChanged"  hideFilter/>
        <div class="table-responsive text-center table-custom">
          <b-table
            class="table-custom text-left table-centered"
            :items="vaAccountTransactionsData"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-compare="sortByDate"
            :sort-desc.sync="sortDesc"
            sticky-header="50vh"
            show-empty
            :empty-text="$t('common.no-records')"
            busy.sync="true"
            hover
          >
            <template v-slot:head()="data">
              <span v-b-tooltip.hover.top :title="$t(data.field.tooltip)">
                {{ $t(data.label) }}
              </span>
            </template>

            <template  v-slot:cell(date)="row">
                <p class="table-date">{{ row.value | date }}</p>
                <p class="table-time">{{ row.value | time }}</p>
            </template>

            <template  v-slot:cell(vaaccount_no)="row">
                <span class="text-chai">{{ row.value }}</span>
            </template>

            <template v-slot:cell(amount)="row">
              <div>
                <span class="align-middle">{{
                  row.value.toLocaleString("en-US", {
                    style: "currency",
                    currency: row.item.currency,
                  })
                }}</span>
              </div>
            </template>

            <template v-slot:cell(balance)="row">
              <div>
                <span class="align-middle">{{
                  row.value.toLocaleString("en-US", {
                    style: "currency",
                    currency: row.item.currency,
                  })
                }}</span>
              </div>
            </template>

            <template v-slot:cell(txn_type)="row">
              <div
                class="badge font-size-12"
                 style="padding: 6px 12px;border-radius: 8px;font-size: 12px;line-height: 20px;"
                :class="{
                  'badge-soft-danger': `${row.value}` === 'Debit',
                  'badge-soft-success': `${row.value}` === 'Credit'
                }"
              >{{ row.value}}</div>
            </template>

          </b-table>
          <Spinner v-if="isFetchingTransactions === true"></Spinner>
          <div class="d-flex justify-content-between flex-wrap" style="gap: 10px;">
            <per-page
              v-model="perPage"
              :currentPage="currentPage"
              :totalRows="rows"
              :tableRowsCount="vaAccountTransactionsData.length"
              @input="refreshRecord"
            />
            <b-pagination
              class="my-auto"
              v-model="currentPage"
              :current-page="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              @input="refreshRecord"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
    <!-- create virtual account form not in use for now -->
    <!-- <div>
      <b-modal
        size="lg"
        id="modal-2"
        centered
        v-model="showmodal"
        title="Create Virtual Account"
        title-class="text-dark font-18"
        no-close-on-backdrop
        hide-footer
      >
        <form id="modal" @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="Benefactor Name">
                  <i class="mdi mdi-account"></i>

                  {{ $t("views.payouts.benefactor-name") }}
                  <span class="text-danger mr-1">*</span>
                  <i class="ri-information-line ml-1" id="Benefactor"></i>
                  <b-tooltip target="Benefactor">
                    {{ $t("views.payouts.party_name_msg") }}
                  </b-tooltip>
                </label>
                <input
                  type="text"
                  class="form-control"
                  style="text-transform: uppercase"
                  :placeholder="$t('views.payouts.benefactor-name')"
                  name="customer_name"
                  v-model="chaiPayVirtualAccounts.customer_name"
                  :class="{
                    'is-invalid':
                      submitted &&
                      $v.chaiPayVirtualAccounts.customer_name.$error,
                  }"
                />
                <div
                  v-if="
                    submitted &&
                    !$v.chaiPayVirtualAccounts.customer_name.required
                  "
                  class="invalid-feedback"
                >
                  {{ $t('views.payouts.required_field_msg.customer_name') }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="Bank Code">
                  <i class="mdi mdi-bank"></i>

                  {{ $t("views.payouts.bank-code") }}
                  <span class="text-danger mr-1">*</span>
                  <i class="ri-information-line ml-1" id="bank"></i>
                  <b-tooltip target="bank">
                    {{ $t('views.payouts.unique_bank_code_msg') }}
                  </b-tooltip>
                </label>

                <select
                  name="bankcode"
                  class="form-control"
                  v-model="chaiPayVirtualAccounts.bank_code"
                  :class="{
                    'is-invalid':
                      submitted && $v.chaiPayVirtualAccounts.channel_key.$error,
                  }"
                >
                  <div
                    v-if="
                      submitted &&
                      !$v.chaiPayVirtualAccounts.channel_key.required
                    "
                    class="invalid-feedback"
                  >
                    {{ $t('views.payouts.required_field_msg.bank_code') }}
                  </div>
                  <option value="WOORIBANK">WOORIBANK</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="Channel Key">
                  <i class="mdi mdi-key"></i>

                  {{ $t("views.payouts.channel-key") }}
                  <span class="text-danger mr-1">*</span>
                  <i class="ri-information-line ml-1" id="b"></i>
                  <b-tooltip target="b">
                    {{ $t('views.payouts.channel_name_msg') }}
                  </b-tooltip>
                </label>

                <select
                  name="channelkey"
                  class="form-control"
                  v-model="chaiPayVirtualAccounts.channel_key"
                  :class="{
                    'is-invalid':
                      submitted && $v.chaiPayVirtualAccounts.channel_key.$error,
                  }"
                >
                  <div
                    v-if="
                      submitted &&
                      !$v.chaiPayVirtualAccounts.channel_key.required
                    "
                    class="invalid-feedback"
                  >
                    {{ $t('views.payouts.required_field_msg.channel_key') }}
                  </div>
                  <option value="EPAY_PAYOUT">EPAY_PAYOUT</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="Address">
                  <i class="mdi mdi-home-map-marker"></i>
                  {{ $t("views.payouts.address") }}
                </label>
                <input
                  id="f"
                  type="text"
                  class="form-control"
                  placeholder="Address"
                  name="address"
                  v-model="chaiPayVirtualAccounts.address"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="Phone">
                  <i class="mdi mdi-phone mr-2"></i>
                  {{ $t("views.payouts.phone") }}
                </label>

                <input
                  type="number"
                  class="form-control"
                  name="phone"
                  placeholder="Phone Number"
                  maxlength="13"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  v-model="chaiPayVirtualAccounts.phone"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="Email">
                  <i class="mdi mdi-email-outline"></i>

                  {{ $t("views.payouts.email") }}
                </label>

                <input
                  type="email"
                  class="form-control"
                  placeholder="Email Address"
                  name="email"
                  v-model="chaiPayVirtualAccounts.email"
                />
              </div>
            </div>
          </div>

          <div class="text-right">
            <b-button class="mr-1" variant="light" @click="hideModal"
              >{{ $t("button.close") }}
            </b-button>

            <button
              type="submit"
              class="btn btn-primary ml-1"
            >
              {{ $t("views.payouts.create-account") }}
            </button>
          </div>
        </form>

        <div>
          <b-modal
            centered
            title="Virtual Account"
            v-model="createError"
            title-class="text-dark font-18"
            no-close-on-backdrop
            hide-footer
          >
            <p>{{ errorMessage }}</p>
          </b-modal>
        </div>

        <div>
          <b-modal
            centered
            title="Virtual Account"
            v-model="successfulMessage"
            title-class="text-dark font-18"
            no-close-on-backdrop
            hide-footer
          >
            <div
              class="failure-modal"
              style="display: grid; justify-content: center"
            >
              <img src="@/assets/images/success.png" alt height="100" />
              <p>{{ $t("views.payouts.virtual-successfull") }}</p>
            </div>
          </b-modal>
        </div>
      </b-modal>
    </div> -->
    <!-- end modal -->
    </div>
  </Layout>
</template>

<style scoped>
input:focus:required:invalid {
  color: green;
}
.virtual-acc-card{
  margin-bottom:20px; 
  border: 1px #DCDAD5 solid;
  border-radius: 12px;
  padding: 24px;
  height: 178px;
  cursor: pointer;
}
.virtual-acc-card:hover {
  border: 1px #FC6B2D solid;
  box-shadow: 0px 0px 0px 4px rgba(252, 107, 45, 0.15);
}
.virtual-acc-card.active {
  border: 1px #FC6B2D solid;
  box-shadow: 0px 0px 0px 4px rgba(252, 107, 45, 0.15);
}
.dummy-virtual-account{
    width: 100%;
    height: 450px;
}
.badge-soft-danger{
    background: rgba(222, 53, 53, 0.10);
    color: #DE3535;
}
.badge-soft-success{
    background: rgba(33, 150, 83, 0.10);
    color: #219653;
}
</style>









